// @deprecated - for TS, use StaffType.ts instead. Use this for plain JS files only
export default {
  PHYSICIAN: 'Physician',
  STAFF: 'OfficeStaff',
};
